const buildVersion = "24.1.16"
const buildId = "24.1.16-63c1b28"

export { buildId, buildVersion }
